import { BudgetProposalT, InscriptionWithMetadata } from '../config/types';
import {
    getBudgetProposalFromInscription,
    InscriptionT,
} from '../shared/entities/inscription';

/**
 * Builds an array of inscriptions with phase (based on their parent BudgetProposal).
 */
export const buildInscriptionsWithPhase = ({
    inscriptions,
    budgetProposals,
}: {
    inscriptions: InscriptionT[] | undefined;
    budgetProposals: BudgetProposalT[];
}): InscriptionWithMetadata[] => {
    if (!inscriptions) {
        return [];
    }
    return inscriptions.map((inscription) => ({
        inscription,
        budgetProposalPhase: getBudgetProposalFromInscription(
            inscription,
            budgetProposals,
        ).phase,
    }));
};
